<template>
  <section class="form-view">
    <b-button-group v-if="windowWidth > 500">
      <form-link
        v-show="forms.length > 1"
        v-for="(form,index) in forms"
        :key="index"
        :orchestration="form.orchestration"
        :form="form.name"
        :stepNumber="form.stepText"
        :stepName="form.stepName"
        :step="form.step">
      </form-link>
    </b-button-group>
      <b-button-group v-else >
        <form-link v-if="currentForm"
          v-show="forms.length > 1"
          :orchestration="form.orchestration"
          :form="form.name"
          :stepNumber="form.stepText"
          :stepName="form.stepName"
          :step="form.step">
        </form-link>
    </b-button-group>
    <div id="currentComponent">
    <b-input-group size="lg">
      <component :is="component" :actionSet="actionSet"></component>
    </b-input-group>
    </div>
  </section>
</template>

<script>
/***************************************************
   * The FormView component
   *
   * Maintains the current page of the Orchestration
   * Step Number of the FormOrchestration is held here
   *
   * Bound to passed in orchestration name
   * Bound to passed in form name
   * Bound to the step of the orchestration
   *
   * Hold Form component(s)
   ***************************************************/
import FormLink from './FormLink.vue'
import { storeToRefs } from 'pinia'
import { useFormOrchestrationStore } from '../../stores/formOrchestration'

export default {
  name: 'form-view',
  data () {
    return {
      actionSet: [],
      windowWidth: 0
    }
  },
  props: {
    requestedForm: {
      type: String,
      required: true
    },
    orchestration: {
      type: String,
      required: true
    }
  },
  computed: {
    currentForm: {
      get () {
        const store = useFormOrchestrationStore()
        return store.currentForm
      },
      set (value) {
        const store = useFormOrchestrationStore()
        store.updateCurrentForm(value)
      }
    },
    forms: {
      get () {
        const store = useFormOrchestrationStore()
        const orchestration = store.orchestrations.find(o => o.name === this.orchestration)
        return orchestration ? orchestration.forms : []
      }
    },
    component: {
      get () {
        const cur = this.forms.find(f => f.name === this.currentForm)
        return cur ? cur.component : null
      }
    },
    form: {
      get () { return this.forms.find(f => f.name === this.currentForm) }
    }
  },
  components: {
    'form-link': FormLink
  },
  methods: {
    onResize () {
      this.windowWidth = window.innerWidth
    }
  },
  mounted () {
    this.windowWidth = window.innerWidth;
    window.addEventListener('resize', this.onResize)
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped>
  .btn-group {
    width: 100%;
    background-color: #c6c5c5;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
  }

  .btn-primary {
    background-color: #00456b;
    height: 55px;
    border-color: #00456b;
  }

  .btn-secondary {
    background-color: #123A5D;
    height: 55px;
    border-color: #123A5D;
  }

  button {
    margin: 0 15px;
  }

  /* Let the current form content participate in normal document flow.
     The previous absolute positioning created extra scroll and layout gaps. */
  .input-group {
    background-color: #E7E7E7;
    padding: 15px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
  }

  /* Make the orchestration view flex-friendly so the footer can stick correctly */
  .form-view {
    display: flex;
    flex-direction: column;
    flex: 1 0 auto; /* grow to fill available space under header */
    background-color: #E7E7E7; /* match darker grey used across pages */
    min-height: auto;
  }

  @media only screen and (max-width: 650px) {
    .input-group {
      padding: 12px;
    }
  }

  @media only screen and (max-width: 390px) {
    .btn-primary {
      margin-bottom: 65px;
      margin-left: 0px;
    }
  }
</style>
